'use client'

import { LightCard } from '@algoacademy/design-system/web/data-display/Card'
import { ClientPreview } from '@algoacademy/design-system/web/forms/MarkdownEditor/_components/MarkdownEditor/ClientPreview'
import { H2 } from '@algoacademy/design-system/web/typography/Heading'

type HowIWorkProps = {
  markdown: string
}

export function HowIWork({ markdown }: HowIWorkProps) {
  return (
    <div className='flex flex-col items-center justify-center space-y-6'>
      <H2>Współpraca ze mną</H2>
      <LightCard className='max-w-5xl'>
        <ClientPreview content={{ markdown }} />
      </LightCard>
    </div>
  )
}
